import { createAction } from '@sde/widgets-core/src/redux/helpers/createAction';
import { SET_REQUIREDFILTER } from './constants';

export const setRequiredFilter = (requiredFilter) => {
  return createAction({
    type: SET_REQUIREDFILTER,
    payload: requiredFilter,
  });
};
